import { render } from "./ModalFooter.vue?vue&type=template&id=309049dd&ts=true"
import script from "./ModalFooter.vue?vue&type=script&lang=ts"
export * from "./ModalFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__